export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const gtmConfig = config.public.gtm;

  if (!gtmConfig?.enabled || !gtmConfig?.id) {
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // GTM Script injection
  if (gtmConfig.loadScript) {
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=${!gtmConfig.defer};
      ${gtmConfig.defer ? 'j.defer=true;' : ''}
      ${gtmConfig.compatibility ? 'j.async=true;j.defer=true;' : ''}
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmConfig.id}');
    `;
    document.head.appendChild(script);

    // Add noscript iframe for GTM
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmConfig.id}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  // GTM helper functions
  const gtm = {
    trackEvent(event: Record<string, any>) {
      if (!process.client || !gtmConfig.enabled) return;

      if (gtmConfig.debug) {
        console.log('[GTM] Track event:', event);
      }

      if (window.dataLayer) {
        window.dataLayer.push(event);
      }
    },

    trackView(screenName: string, path?: string, additionalData?: Record<string, any>) {
      if (!process.client || !gtmConfig.enabled) return;

      const event = {
        event: 'content-view',
        'content-name': path || screenName,
        'content-view-name': screenName,
        ...additionalData,
      };

      if (gtmConfig.debug) {
        console.log('[GTM] Track view:', event);
      }

      if (window.dataLayer) {
        window.dataLayer.push(event);
      }
    },
  };

  // Router sync - track page views
  if (gtmConfig.enableRouterSync) {
    nuxtApp.hook('page:finish', () => {
      const router = useRouter();
      const route = useRoute();

      const trackPage = () => {
        if (gtmConfig.trackOnNextTick) {
          nextTick(() => {
            gtm.trackView(route.name as string, route.path);
          });
        } else {
          gtm.trackView(route.name as string, route.path);
        }
      };

      trackPage();
    });
  }

  return {
    provide: {
      gtm,
    },
  };
});
